<script>
  import { mapGetters } from 'vuex'
  import { pickBy } from '../utils'

  export default {
    name: 'ThankyouPage',

    computed: {
      ...mapGetters(['getLabel', 'getPatientData', 'getSubmitStatus', 'getPrivacyAgreementData']),

      privacyDataCompletionKeywordsForGTM: function(){
          return Object.keys(pickBy(this.getPrivacyAgreementData)).sort().join(" ");
      }
    },

    methods: {
      goToHome: function () {
        window.location.href = this.$config.homepage;
      }
    },

    mounted(){
      if (this.getSubmitStatus) {
        this.$analytics.pushEvent("form:completed");
        this.$analytics.pushEvent("privacy:data-completion", this.privacyDataCompletionKeywordsForGTM);
      } else {
        this.$analytics.pushEvent("form:submit-error");
      }
    }
  }

</script>

<template>
    <div class="col-12">
        <div class="thankyou-page checked" v-if="getSubmitStatus">
            <h4>
                <Msg id="ospedali.form.thankyoupage.title"/>
            </h4>
            <h2>
                <Msg id="ospedali.form.thankyoupage.heading"/>
                <span class="highlighted"> {{getPatientData.applicantEmail}}</span>
            </h2>
            <div>
                <p>
                    <Msg id="ospedali.form.thankyoupage.text"/>
                </p>
            </div>

            <div class="wrap-main-cta">
                <button @click="goToHome()" class="button-primary">{{getLabel('ospedali.form.button.backtohome')}}</button>
            </div>
        </div>
        <div class="thankyou-page error" v-else="">
            <h4>
                <Msg id="ospedali.form.thankyoupage.titleerror"/>
            </h4>
            <h2>
                <Msg id="ospedali.form.thankyoupage.headingerror"/>
            </h2>
            <div class="wrap-main-cta">
                <button @click="goToHome()" class="button-primary">{{getLabel('ospedali.form.button.backtohome')}}</button>
            </div>
        </div>
    </div>
</template>